import React from 'react'

import './QbIcon.css'

const QbIcon = ({ large, loading }) => 
  <div
    style={large ? ICON_STYLE.large : ICON_STYLE.small}
    className={`qb-icon ${loading ? 'qb-icon--loading' : ''}`}
  />

export default QbIcon

const ICON_STYLE = {
  large: {
    width: '50px',
    height: '50px'
  },
  small: {
    width: '20px',
    height: '20px'
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/QbIcon/QbIcon.js